import { eventsResource, EventsResource } from '@/resources/events.resource';
import { AbstractModule } from './abstract.module';

/**
 * Moduł wydarzeń
 *
 * @class EventsModule
 * @extends {AbstractModule<EventsResource>}
 */
export class EventsModule extends AbstractModule<EventsResource> {
  /**
   * Dane wydarzeń
   *
   * @memberof EventsModule
   */
  public state = {
    list: []
  };

  public mutations = {
    /**
     * Zapisuje wydarzenia
     *
     * @param {*} localState
     * @param {*} events
     */
    saveEvents(localState: any, events: any): void {
      localState.list = events;
    }
  };
  public actions = {
    /**
     * Pobiera wydarzenia
     *
     * @param context context
     * @param params parametry
     */
    list: async (context: any, params: { id: number; eventType: string; start: Date; end: Date }): Promise<void> => {
      const events = await (this.resource as any)[params.eventType](params.id, params.start, params.end);
      context.commit('saveEvents', events);
    }
  };
  constructor() {
    super(eventsResource);
  }
}

export default new EventsModule();
